module.exports = __webpack_public_path__ + "img/613.49907fc7.png";